// assets/curator-templates.js



(function () {
  const form = document.getElementById('ctg-form');
  if (!form) return;

  // --- EXISTING refs (keep yours) ---
  const nameInput = document.getElementById('ctg-name');
  const codeInput = document.getElementById('ctg-code');
  const errorEl   = document.getElementById('ctg-error');
  const outputEl  = document.getElementById('ctg-output');

  // Subject: support either an <input id="ctg-subject-input"> or a contenteditable <div id="ctg-subject-editor">
  const subjectInput   = document.getElementById('ctg-subject-input');   // optional
  const subjectEditor  = document.getElementById('ctg-subject-editor');  // optional
  const copySubjectBtn = document.getElementById('ctg-copy-subject');
  const copySubjectStatus = document.getElementById('ctg-copy-subject-status');

  const previewEl = document.getElementById('ctg-email-preview'); // contenteditable body
  const rawArea   = document.getElementById('ctg-email-raw');
  const copyBtn   = document.getElementById('ctg-copy');
  const copyStatus = document.getElementById('ctg-copy-status');

  // ---------- CE GUARD: never allow truly-empty contenteditable ----------
  function setPlaceholder(el, placeholder) {
    if (!el) return;
    el.setAttribute('data-placeholder', placeholder || '');
    ensureNotEmpty(el);
    el.addEventListener('input', () => {
      // If user wiped everything, reinsert placeholder BR
      if (el.textContent.trim() === '') {
        el.classList.add('is-empty');
        ensureNotEmpty(el);
      } else {
        el.classList.remove('is-empty');
        // Remove any ghost placeholders accidentally left behind
        el.querySelectorAll('[data-ctg-placeholder]').forEach(n => n.remove());
      }
    });
    el.addEventListener('paste', () => {
      // After paste, it won't be empty; clear ghost if present
      el.classList.remove('is-empty');
      el.querySelectorAll('[data-ctg-placeholder]').forEach(n => n.remove());
    });
    el.addEventListener('focus', () => {
      // Keep caret visible even when empty
      if (el.textContent.trim() === '') {
        el.classList.add('is-empty');
        ensureNotEmpty(el);
      }
    });
    el.addEventListener('blur', () => {
      // If they leave it empty, keep placeholder for layout
      if (el.textContent.trim() === '') {
        el.classList.add('is-empty');
        ensureNotEmpty(el);
      }
    });
  }

  function ensureNotEmpty(el) {
    // If truly empty, inject a ghost <br> so :empty isn’t matched
    const html = (el.innerHTML || '').replace(/\s|&nbsp;/g, '');
    if (!html || html === '<br>' || html === '<div><br></div>') {
      el.innerHTML = '<br data-ctg-placeholder="1">';
    }
  }

  function getCleanEditableHtml(el) {
    // Clone, remove ghost placeholders, then return innerHTML
    const clone = el.cloneNode(true);
    clone.querySelectorAll('[data-ctg-placeholder]').forEach(n => n.remove());
    return clone.innerHTML.trim();
  }

  // Apply guard to any CE editors that exist on the page
  setPlaceholder(previewEl, 'Write or edit your email here…');
  // If you’re using the older contenteditable subject:
  setPlaceholder(subjectEditor, 'Type your subject here…');

 
  function escapeHtml(str) {
    return str.replace(/[&<>"']/g, s => ({
      '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'
    }[s]));
  }

  function normalizeCode(raw) {
    const t = (raw || '').trim();
    if (!t) return t;
    // If they pasted a full URL, extract last non-empty path segment
    try {
      const u = new URL(t);
      const parts = u.pathname.split('/').filter(Boolean);
      return parts.pop() || t;
    } catch (e) {
      const parts = t.split('/').filter(Boolean);
      return parts.pop() || t;
    }
  }

  function buildEmailHtml(name, curatorCode) {
    const safeName = escapeHtml(name);
    const encodedCode = encodeURIComponent(curatorCode);

    // #9: "Watch the film with discount!" is styled as a red button via inline styles AND class.
    const ctaStyle = 'display:inline-block;background:#b90000;color:#fff;padding:10px 14px;border-radius:6px;text-decoration:none;font-weight:600';

    return `
      <p>Hello,</p>

      <p>As a proud backer of <em>I Know Catherine, the Log Lady</em>, I am sending you a special discount code as I think we should all see it. It is about friendship, Twin Peaks, David Lynch and life.</p>

      <p><a class="ctg-cta" style="${ctaStyle}" href="https://joma.film/films/i-know-catherine/${encodedCode}">Watch the film with a discount!</a></p>

      <p>Screening this film can help us all open a dialogue about living a deeper, more meaningful life.</p>

      <p><a href="https://iknowcatherine.com/pages/how-it-works-for-curators">Watch this brief video to understand how it works.</a></p>

      <p>“Life gives more than death can take away” and <em>I Know Catherine, The Log lady</em> delivers powerful inspiration for living every moment in the fullest possible way.</p>

      <p><a href="https://iknowcatherine.com/pages/trailer">Watch trailer</a></p>

      <p>I look forward to hearing your reaction…<br>
      Best,<br>
      ${safeName}</p>
    `.trim();
  }

  function htmlToPlain(html) {
    // Convert HTML to readable text: render links as "Text (URL)"
    const container = document.createElement('div');
    container.innerHTML = html;
    container.querySelectorAll('a').forEach(a => {
      a.insertAdjacentText('afterend', ` (${a.href})`);
    });
    return container.innerText;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    copyStatus.textContent = '';

    const name = (nameInput.value || '').trim();
    const code = normalizeCode(codeInput.value);

    if (!name || !code) {
      errorEl.hidden = false;
      return;
    }
    errorEl.hidden = true;

    const emailHtml = buildEmailHtml(name, code);
    previewEl.innerHTML = emailHtml;          // fill editable body
    outputEl.hidden = false;
    outputEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    subjectEditor.focus();
  });

  // Copy email body (preserve rich formatting where supported)
  copyBtn.addEventListener('click', async function () {
    const html = getCleanEditableHtml(previewEl);  // << was previewEl.innerHTML
    const text = htmlToPlain(html);

    try {
      if (navigator.clipboard && window.ClipboardItem) {
        const item = new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([text], { type: 'text/plain' })
        });
        await navigator.clipboard.write([item]);
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        // Fallback to hidden textarea
        rawArea.value = text;
        rawArea.hidden = false;
        rawArea.focus();
        rawArea.select();
        document.execCommand('copy');
        rawArea.hidden = true;
      }
      copyStatus.textContent = 'Copied to clipboard.';
      setTimeout(() => copyStatus.textContent = '', 2500);
    } catch (err) {
      copyStatus.textContent = 'Copy failed. Select and copy manually.';
      console.error('Copy failed:', err);
    }
  });

  // Copy subject text from the editable field
  if (copySubjectBtn) {
    copySubjectBtn.addEventListener('click', async function () {
      const subject = (subjectEditor?.textContent || '').trim();
      if (!subject) return;

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(subject);
        } else {
          rawArea.value = subject;
          rawArea.hidden = false;
          rawArea.focus();
          rawArea.select();
          document.execCommand('copy');
          rawArea.hidden = true;
        }
        copySubjectStatus.textContent = 'Subject copied.';
        setTimeout(() => copySubjectStatus.textContent = '', 2000);
      } catch (e) {
        copySubjectStatus.textContent = 'Copy failed.';
        console.error('Copy subject failed:', e);
      }
    });
  }
})();
